<template>
    <v-dialog v-model="dialog" persistent width="400" @keydown.esc="annulla()">
        <v-card>
            <v-card-title>
                Riprogramma attività
                <v-spacer />
                <v-btn icon @click="annulla()">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text>
                <v-row class="ma-0 pa-0">
                    <v-text-field v-model="pickerDate" label="Nuova data evento" hide-details
                        style="max-width: 150px !important" type="date" @input="updateDate" />
                </v-row>

                <v-row>
                    <v-col cols="12">
                        <v-row dense>
                            <v-col cols="4">
                                <v-menu v-model="menuOraInizio" :close-on-content-click="false" offset-y
                                    max-width="290px" min-width="290px" :disabled="localTask.giornoIntero">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-model="localTask.oraInizio" label="Ora inizio" v-bind="attrs"
                                            clearable @click:prepend="menuOraInizio = true"
                                            :disabled="localTask.giornoIntero" @blur="normalizzaOra('oraInizio')">
                                            <template v-slot:prepend>
                                                <v-icon tabindex="-1" @click="menuOraInizio = true">access_time</v-icon>
                                            </template>
                                        </v-text-field>
                                    </template>
                                    <v-time-picker v-if="menuOraInizio" v-model="localTask.oraInizio" full-width
                                        @click:minute="menuOraInizio = false" format="24hr" />
                                </v-menu>
                            </v-col>

                            <v-col cols="1" class="d-flex align-center justify-center pa-0">
                                <span style="font-size: 1.2rem;">-</span>
                            </v-col>

                            <v-col cols="4">
                                <v-menu v-model="menuOraFine" :close-on-content-click="false" offset-y max-width="290px"
                                    min-width="290px" :disabled="localTask.giornoIntero">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-model="localTask.oraFine" label="Ora fine" v-bind="attrs"
                                            clearable @click:prepend="menuOraFine = true"
                                            :disabled="localTask.giornoIntero" @blur="normalizzaOra('oraFine')">
                                            <template v-slot:prepend>
                                                <v-icon tabindex="-1" @click="menuOraFine = true">access_time</v-icon>
                                            </template>
                                        </v-text-field>
                                    </template>
                                    <v-time-picker v-if="menuOraFine" v-model="localTask.oraFine" full-width
                                        @click:minute="menuOraFine = false" format="24hr" />
                                </v-menu>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-actions>
                <v-spacer />
                <v-btn @click="annulla()">Annulla</v-btn>
                <v-btn @click="salva()" color="primary">Conferma</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { save_task } from "@/api/api.calendar.js"

export default {
    name: "DialogRiprogramma",

    props: {
        task: { type: Object, default: () => null },
        dialog: { type: Boolean, default: false },
    },

    data: () => ({
        localTask: {},
        calendarData: false,
        pickerDate: null,

        menuOraInizio: false,
        menuOraFine: false,
    }),

    methods: {
        annulla(aggiorna = false) {
            this.$emit("chiudi", aggiorna);
        },

        async salva() {
            let res = await save_task(this.localTask, "/riprogramma");
            if (res.data == "OK") this.annulla(true);
            else this.$toast.error(res.data);
        },

        formatDateIT(dateStr) {
            if (!dateStr) return "";
            const d = new Date(dateStr);
            return d.toLocaleDateString("it-IT");
        },

        updateDate(val) {
            this.localTask.nuovaData = `${val}T00:00:00`;
            this.localTask.dataIT = this.formatDateIT(this.localTask.nuovaData);
            this.calendarData = false;
        },

        normalizzaOra(campo) {
            let val = this.localTask[campo];
            this.localTask[campo] = this.$functions.normalizzaOra(val);
        },
    },

    watch: {
        dialog(val) {
            if (val && this.task) {
                this.localTask = { ...this.task };
                // Inizializza campi formattati
                this.localTask.nuovaData = this.task.data;
                this.localTask.dataIT = this.formatDateIT(this.task.data);
                this.pickerDate = this.task.data
                    ? this.task.data.substring(0, 10)
                    : null;
            } else {
                this.localTask = {};
                this.pickerDate = null;
            }
        },
    },
};
</script>
